module.exports = __webpack_public_path__ + "static/img/index-v3-bg.8829aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index-v3-bg.png
// module id = oH/J
// module chunks = 68